import { useNavigate } from "react-router";
import { createSearchParams } from "react-router-dom";

export const transformActivityData = (rawData) => {
  return rawData.map((item, index) => ({
    serial: item.serial + (index + 1),
    app_install_id: item.id,
    user: item.user,
    plan_type: item.plan_type,
    activityType: item.activityType,
    currentPlanStatus: item.currentPlanStatus,
    shopifyPlan: item.shopifyPlan || "",
    store_name: item.store_name,
    store_url: item.shop_name,
    action: item.action,
    date: FormatDateTime(item.date),
  }));
};

export const FormatDateTime = (rawDate) => {
  const date = new Date(rawDate);

  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const yyyy = date.getFullYear();

  const hh = String(date.getHours()).padStart(2, "0");
  const min = String(date.getMinutes()).padStart(2, "0");
  const ss = String(date.getSeconds()).padStart(2, "0");

  return `${dd}/${mm}/${yyyy} - ${hh}:${min}:${ss}`;
};

export const Positive = (e, id, refrer) => {
  console.log(id, refrer, "id, refrerid, refrerid, refrer");
  const navigation = useNavigate();
  navigation({
    pathname: refrer,
    search: createSearchParams({ id }).toString(),
  });
};

export const Formatdata = (data) => {
  let modifiedData = [];
  modifiedData = data.map((key, index) => {
    return {
      active_plan_name: key.active_plan_name,
      app_install_id: key.app_install_id,
      country: key.country,
      date: FormatDateTime(key.date),
      shop_email: key.shop_email,
      shop_phone: key.shop_phone,
      status: key.status,
      store_owner: key.store_owner,
      shop_name: key.shop_name,
      store_name: key.store_name,
    };
  });
  return modifiedData;
};

export const formatDate = (date) => {
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
};